import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { AppDispatch } from "store/store";
import styles from "./ShareScreenBtnGroup.module.css";
import { toggleChat } from "../../../store/chat-messages/slice";
import { Icon } from "../icon/Icon";

export const ShareScreenBtnGroup: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { showChat, unreadCount } = useSelector(
    (s: RootState) => s.chatMessages
  );

  return (
    <div className={`btn-group ${styles["btn-group"]}`}>
      <button onClick={() => dispatch(toggleChat(false))} className={`${!showChat ? styles["selected"] : ""}`}>
        <Icon id={"users"}  />
      </button>
      <button onClick={() => dispatch(toggleChat(true))} className={`${!showChat ? "" : styles["selected"]}`} >
        <Icon id={"chat"} />
        {(unreadCount > 0 && !showChat) && (
          <span className={`${styles["badge"]}`}>
            { unreadCount }
          </span>
        )}
      </button>
    </div>
  );
};
